import React from 'react';

import { Field } from 'redux-form';

import * as Dropdown from 'components/Dropdown';

const TestSelectionComponent = props =>
  <div className="main-dropdown mb-20">
    <p className="main-dropdown__label">
      Test Parameter
    </p>

    <Field
      {...props}
      name="testSelection"
      placeholder="Select a Test Parameter"
      component={Dropdown.ReduxFormWrapper}
    />
  </div>;

export default TestSelectionComponent;
